import React, { Component } from "react";
import { Link } from "react-router-dom";

class FaqV1 extends Component {
  render() {
    return (
      <div className="ltn__faq-area mb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__faq-inner ltn__faq-inner-2">
                <div id="accordion_2">
                  {/* card */}
                  <div className="card">
                    <h6
                      className="collapsed ltn__card-title"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-item-2-1"
                      aria-expanded="false"
                    >
                      Q: What is the procedure to place an order?
                    </h6>
                    <div
                      id="faq-item-2-1"
                      className="collapse accordion-collapse "
                      data-bs-parent="#accordion_2"
                    >
                      <div className="card-body">
                        You have to fill in the online order form with every
                        required field. After it, click on ‘Get Price’ button to
                        see our pricing structure. Proceed with your selection
                        of price and standard for the table of prices. We would
                        also like to bring it to your notice that pricing for a
                        few of the orders depends on the nature of your
                        customized requirements; therefore it won’t be possible
                        to provide you with the exact cost of your paper
                        immediately. For instance, to fulfil editing,
                        modification, proofreading or any ad hoc requirement, we
                        have to discuss the pricing with our writers. Next step
                        is to fill in the requirements section and proceed to
                        the payment page. The order process completes when you
                        select a method to pay for our services and make the
                        payment. Once the payment is made, we will start working
                        on your project.
                      </div>
                    </div>
                  </div>
                  {/* card */}
                  <div className="card">
                    <h6
                      className="collapsed ltn__card-title"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-item-2-2"
                      aria-expanded="false"
                    >
                      Q: Are your custom written papers committed to
                      originality?
                    </h6>
                    <div
                      id="faq-item-2-2"
                      className="collapse "
                      data-bs-parent="#accordion_2"
                    >
                      <div className="card-body">
                        <p>
                          Yes, we provide guaranteed original work, and we never
                          resell or republish the papers written especially for
                          you..
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* card */}
               
                  {/* card */}
                  <div className="card">
                    <h6
                      className="collapsed ltn__card-title"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-item-2-4"
                      aria-expanded="false"
                    >
                      Q: Which subjects do you cover for thesis writing?s
                    </h6>
                    <div
                      id="faq-item-2-4"
                      className="collapse"
                      data-bs-parent="#accordion_2"
                    >
                      <div className="card-body">
                        <p>
                          We offer comprehensive academic help for a broad range
                          of subjects at all academic levels, including high
                          school, graduation, post graduation, and doctorate
                          level. The order form page has a menu that depicts our
                          specialization, choose your subject from the list or
                          enter manually to get our services.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <h6
                      className="collapsed ltn__card-title"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-item-2-3"
                      aria-expanded="false"
                    >
                      Q: What is the pricing structure to order an thesis?
                    </h6>
                    <div
                      id="faq-item-2-3"
                      className="collapse"
                      data-bs-parent="#accordion_2"
                    >
                      <div className="card-body">
                        <p>
                          Our prices will be available only when you complete
                          the order form mentioning all your specifications and
                          proceed to know the pricing structure.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* card */}
                  <div className="card">
                    <h6
                      className="collapsed ltn__card-title"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-item-2-5"
                      aria-expanded="false"
                    >
                      Q: How long will I wait to get my order done?
                    </h6>
                    <div
                      id="faq-item-2-5"
                      className="collapse"
                      data-bs-parent="#accordion_2"
                    >
                      <div className="card-body">
                        <p>
                          Turn around time for each academic paper varies from
                          one day to one month, depending upon the kind of
                          document requested as well as on the availability of
                          the expert. You can select the urgency while filling
                          in the order form; prices may vary depending upon how
                          urgently you need to get the thesis delivered
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* card */}
                  <div className="card">
                    <h6
                      className="collapsed ltn__card-title"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-item-2-6"
                      aria-expanded="false"
                    >
                      Q: What are the details required by the writer to complete
                      my order?
                    </h6>
                    <div
                      id="faq-item-2-6"
                      className="collapse"
                      data-bs-parent="#accordion_2"
                    >
                      <div className="card-body">
                        <p>
                          Yes, when you complete the order form, you can fill in
                          the menu of specific sources to provide us with the
                          reference. We may ask for an electronic variant or
                          scanned copy of your reference.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* card */}
                  <div className="card">
                    <h6
                      className="collapsed ltn__card-title"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-item-2-7"
                      aria-expanded="false"
                    >
                      Q: How is assignment writing different from other service
                      providers?
                    </h6>
                    <div
                      id="faq-item-2-7"
                      className="collapse"
                      data-bs-parent="#accordion_2"
                    >
                      <div className="card-body">
                        <p>
                          We are not like other fake service providers that call
                          themselves ‘as the UK-based’ but operate from abroad.
                          What makes us different is that we are the UK
                          registered company that protects you under UK Consumer
                          Law. All our writers are educated from the top UK
                          universities and native English speakers. Our customer
                          service representatives are well-trained to provide
                          you with one-to-one assistance round-the-clock. We
                          serve you on the basis of 100% assured satisfaction.
                          Thus, we strive and present ourselves as the best
                          thesis writing service provider in the UK.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <h6
                      className="collapsed ltn__card-title"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-item-2-8"
                      aria-expanded="false"
                    >
                      Q: Do I get calculation services with my order?
                    </h6>
                    <div
                      id="faq-item-2-8"
                      className="collapse"
                      data-bs-parent="#accordion_2"
                    >
                      <div className="card-body">
                        <p>
                          Yes, our writers can calculate to do your thesis.
                          When you tick the calculation option in the order
                          form, our writers will calculate any equation related
                          to formulas, ratios, profit & loss and financial
                          analysis. You will be charged with extra fee for
                          availing calculating service..
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <h6
                      className="collapsed ltn__card-title"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-item-2-9"
                      aria-expanded="false"
                    >
                      Q: Can you guarantee plagiarism-free academic work?
                    </h6>
                    <div
                      id="faq-item-2-9"
                      className="collapse"
                      data-bs-parent="#accordion_2"
                    >
                      <div className="card-body">
                        <p>
                          Yes, we offer plagiarism-free academic work to our
                          valued customers. All work done by our experts come
                          with 100% money back guarantee, so you can claim money
                          back in case the originality of the submitted work is
                          found below the set university standards.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="need-support text-center mt-100">
                  <h2>Still need help? Reach out to support 24/7:</h2>
                  <div className="btn-wrapper mb-30 go-top">
                    <Link to="/contact" className="theme-btn-1 btn">
                      Contact Us
                    </Link>
                  </div>
                  <h3>Calling And WhatsApp</h3>
                  <h3>
                    <a
                      href="https://wa.me/+447351212548?text=Referral%20link%20website%3A%20www.assignmentwriting.org"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="icon-call" />UK: +44 7351212548{" "}
                    </a>
                  </h3>
                  <h3>
                    <a
                      href="https://wa.me/+923226320371?text=Referral%20link%20website%3A%20www.assignmentwriting.org"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="icon-call" />  PAK : +92 3226320371
                    </a>
                  </h3>
                  <h3>
                    <a
                      href="https://wa.me/+447312675064?text=Referral%20link%20website%3A%20www.assignmentwriting.org"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="icon-call" /> US Calling Only : 03226320371
                    </a>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FaqV1;
